export interface TaskStatusCount {
    done: number;
    failed: number;
    pending: number;
    running: number;
};